import { Component, InputSignal, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatiqTemplateModule } from '@dat/datiq-components-pkg/template';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'iq-controls-label',
    standalone: true,
    imports: [CommonModule, DatiqTemplateModule, MatIconModule],
    templateUrl: './iq-controls-label.component.html',
    styleUrl: './iq-controls-label.component.scss',
})
export class IqControlsLabelComponent {
    id: InputSignal<string> = input<string>('');
    label = input<string>('--');
}
